export { default } from './InputInfoMessage';
